import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TagModel } from '@fi-shared/models';
import { TagService } from '@fi-app/tag/tag.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { AppTextService } from '@fi-shared/app-text';
import { ModuleType } from '@fi-shared/types/module-type';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

@Component({
    selector: 'fi-checklist-edit-btn-add-section',
    templateUrl: './btn-add-section.component.html',
    styleUrls: ['./btn-add-section.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ChecklistEditBtnAddSectionComponent implements OnInit {
    @Input() addedTagIds: Array<number> = [];
    @Output() onSectionAdd = new EventEmitter<TagModel>();

    @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;

    loadedTags: Array<TagModel> = [];

    constructor(
        private tagService: TagService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {}

    ngOnInit() {
        this.tagService.GetModuleTagsByUserAccessRights(ModuleType.CheckList).then((tags) => {
            this.loadedTags = tags;
        });
    }

    addSectionClick($event) {
        if (!this.loadedTags.length) {
            this.fiDialogsService.error({
                messageText: this.appTextService.get('checklist.no_enabled_tags'),
            });
            this.trigger.closeMenu();
            $event.preventDefault();
        }
    }

    selectTag(tag) {
        this.onSectionAdd.emit(tag);
        this.addedTagIds.push(tag.Id);
    }

    isTagSelected(tag) {
        return this.addedTagIds.indexOf(tag.Id) > -1;
    }
}
